module.exports = __webpack_public_path__ + "static/media/duration_warning.2cc9d65d.svg";